import Address from './Address';
import ErrorsAndOmissions from './ErrorsAndOmissions';

export default class NewProducer {

	public companyName: string | null = null;
	public businessType_Id: number | null = null;
	public heardThrough_Id: number | null = null;
	public physicalAddress: Address | null = null;
	public mailingAddress: Address | null = null;
	public phone: string | null = null;
	public fax: string | null = null;
	public taxId: string | null = null;
	public residentStateLicenseNumber: string | null = null;
	public nationalProducerLicenseNumber: string | null = null;
	public producerAssociationId: number | null = null;
	public externalProducerId: string | null = null;
	public errorsAndOmissionsData: ErrorsAndOmissions | null = null;
	public firstName: string | null = null;
	public lastName: string | null = null;
	public emailAddress: string | null = null;
	public password: string | null = null;

	public constructor() {

	}
};
